import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getFinancialInformation } from '../../api/financial-information';
import {
    FinancialInformationFromatted,
    TaxpayerInformationFormatted,
} from '../../api/types';

export const useFinancialInformation = (
    organizationId: string,
): UseQueryResult<
    FinancialInformationFromatted | TaxpayerInformationFormatted | {}
> =>
    useQuery(
        ['financial-information', organizationId],
        async () => await getFinancialInformation(organizationId),
    );
